/* NgRx */
import { createAction } from '@ngrx/store';

/******** CLEAR STATE ***********/
const CLEAR_STATE = '[search] clear state';
export const ClearState = createAction(CLEAR_STATE);
